import { Component, Input } from '@angular/core';

@Component({
  selector: '[app-flow-dot]',
  templateUrl: './flow-dot.component.html',
  styleUrls: ['./flow-dot.component.scss']
})
export class FlowDotComponent {
  @Input()
  pathAnimation: string;
  @Input()
  fillColor: string;
  @Input()
  strokeColor: string;
  @Input()
  runAnimation: boolean;

  constructor() {
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/flow-dot/flow-dot.component.ts